import { nestApiPath } from 'constants/url'

const createQueryUnAuth = (speciality: string | string[]) => {
  const isSpecArray = Array.isArray(speciality)

  const formatedSpec = isSpecArray ? (speciality as string[]) : [speciality]
  const queryString = formatedSpec.length === 1 ? formatedSpec[0] : formatedSpec.join('&spec=')
  return `${nestApiPath}/unauth-stats/setVisitHistory?spec=${queryString}`
}

export { createQueryUnAuth }
